import React from "react";
import { Link } from "react-router-dom";

import ReUse from "./../services/helpers/reUse";
import CustomImage from "./ReUse/Components/Image";

const BlogCard = (propsData) => {
	const {
		id,
		slug,
		title,
		created_at,
		content,
		blog_category_id,
		image,
		imageurl,
	} = propsData;

	return (
		<>
			<div className="col-md-4">
				<div className="blog-compo-all-dv">
					<div className="blog-compo-img">
						<figure>
							<CustomImage thumbnail={imageurl} />
						</figure>
					</div>
					<div className="blog-compo-text-date">
						<h5>Category : Lorem Ipsum is simply</h5>
						<h5>
							<span>{created_at && created_at}</span>
						</h5>
					</div>
					<div className="only-blog-text">
						<h4>{title && title} </h4>
						<p>{ReUse.removeHTMLTags({ unStripped: content })}</p>
					</div>
					<div className="blog-main-btn">
						<Link to={`/blog-detail/${slug}`} state={slug}>
							read more
						</Link>
					</div>
				</div>
			</div>
		</>
	);
};

export default BlogCard;
